if (!customElements.get('subscription-popup-trigger')) {
  customElements.define(
    'subscription-popup-trigger',
    class SubscriptionPopupTrigger extends HTMLElement {
      connectedCallback() {
        // The popup lives in the overlay group and can be disabled or limited to
        // the homepage, so it is not guaranteed to be on the page. Stay hidden
        // until we know there is something to open.
        this.reveal = this.reveal.bind(this);
        window.FoxTheme.DOMready(this.reveal);
        // The overlay group renders after the header, and the theme editor
        // re-renders either group on its own, so keep watching for a popup
        // instead of deciding once and hiding for good.
        window.addEventListener('load', this.reveal, { once: true });
        this.observer = new MutationObserver(this.reveal);
        this.observer.observe(document.body, { childList: true, subtree: true });
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      reveal() {
        if (this.button) return;
        if (!document.querySelector('subscription-popup')) return;

        this.button = this.querySelector('button');
        // Inline style rather than the hidden attribute: the element carries the
        // theme's `block` utility class, and `.block { display: block }` beats the
        // browser's `[hidden] { display: none }`.
        this.style.display = '';
        this.button.addEventListener('click', this.onClick.bind(this));
        this.observer?.disconnect();
      }

      onClick(event) {
        event.preventDefault();
        // Re-query rather than holding a reference: the theme editor swaps the
        // overlay group out from under us when sections are edited.
        const popup = document.querySelector('subscription-popup');
        if (!popup) return;

        // Set here rather than up front, so the popup's own control binding does
        // not also pick this button up and toggle the popup shut on the same click.
        this.button.setAttribute('aria-controls', popup.id);
        popup.show(this.button);
      }
    }
  );
}
